var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"value":_vm.offOn,"type":_vm.type}},[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }